import React from "react"
import { Button, Checkbox, Collapse, Modal, Select, Typography } from "antd";
import { WarningOutlined } from '@ant-design/icons'
import { Agency } from "./agenciesInterfaces";

interface ApplyFormulaToOtherAgenciesModalProps {
    opened: boolean;
    onClose: () => void;
    selectedAgency: Agency;
    agencies: Agency[];
    propagateConfiguration: (masterAgency: Agency, targetAgencyIds: string[]) => void;
}

export default function ApplyFormulaToOtherAgenciesModal(props: ApplyFormulaToOtherAgenciesModalProps) {
    const { opened, onClose, selectedAgency, agencies, propagateConfiguration } = props;
    const [selectedTargetAgencies, setSelectedTargetAgencies] = React.useState<string[]>([]);

    const availableAgencies = agencies.filter(a => a.agency_id !== selectedAgency.agency_id && !a.deleted);

    const handleSelectAll = (checked: boolean) => {
        if (checked) {
            setSelectedTargetAgencies(availableAgencies.map(a => a.agency_id));
        } else {
            setSelectedTargetAgencies([]);
        }
    };

    const isAllSelected = selectedTargetAgencies.length === availableAgencies.length;
    const isIndeterminate = selectedTargetAgencies.length > 0 && selectedTargetAgencies.length < availableAgencies.length;

    const propagationPopoverContent = (masterAgency: Agency) => (
        <div style={{ padding: '10px' }}>
            <div style={{ marginBottom: '20px' }}>
                <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
                    Agence source: {masterAgency.name}
                </Typography.Text>
            </div>

            <Collapse
                items={[
                    {
                        key: '1',
                        label: "💡 P'tit tips",
                        children: (
                            <ul style={{ margin: '10px 0 0 0', paddingLeft: '20px', fontSize: '13px' }}>
                                <p>Vous allez appliquer la formule de l'agence {masterAgency.name} à une liste d'agences sélectionnées</p>
                                <br />
                                <p>Les agences sélectionnées seront mises à jour avec la formule de l'agence source (nombre de groupement, noms des groupements, critères sélectionnés, configurations supplémentaires liées aux achats par employé,...).</p>
                                <p>Après la mise à jour, uniquement les codes communes du premier groupement de chaque agence seront gardés, le reste sera remplacé.</p>
                            </ul>
                        ),
                    }
                ]}
                style={{ marginBottom: '20px', backgroundColor: '#f0f8ff', borderRadius: '8px' }}
            />
            <div>
                <WarningOutlined style={{ color: '#faad14', fontSize: '16px', marginRight: '8px' }} />
                <Typography.Text type="warning" style={{ fontSize: '14px' }}>
                    Attention, cette action écrasera la configuration actuelle des agences sélectionnées (hors codes communes).
                </Typography.Text>
            </div>

            <div style={{ margin: '10px 0' }}>
                <Checkbox
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    style={{ marginBottom: '8px' }}
                >
                    Sélectionner toutes les agences ({availableAgencies.length})
                </Checkbox>
            </div>

            <Select
                mode="multiple"
                placeholder="Sélectionner les agences cibles"
                style={{ width: '100%', margin: '10px 0' }}
                options={availableAgencies.map(a => ({ label: a.name, value: a.agency_id }))}
                value={selectedTargetAgencies}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                onChange={setSelectedTargetAgencies}
            />

            <Button
                type="primary"
                onClick={() => propagateConfiguration(masterAgency, selectedTargetAgencies)}
                disabled={selectedTargetAgencies.length === 0}
            >
                Propager la configuration
            </Button>
        </div>
    );

    return (
        <Modal
            key={`modal-columns-${selectedAgency.agency_id}`}
            title={
                <Typography.Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                    Appliquer une formule à d'autres agences
                </Typography.Title>
            }
            open={opened}
            onCancel={onClose}
            footer={null}
            width={1200}
            style={{ top: 20 }}
        >
            {propagationPopoverContent(selectedAgency)}
        </Modal>
    )
}